import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelLabel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  removeMember: {
    id: 'studio.ZvdROO',
    defaultMessage: 'Remove member',
  },
  removingMember: {
    id: 'studio.W8lzbA',
    defaultMessage: 'Removing member',
  },
  removeWarning: {
    id: 'studio.FAnTZ3',
    defaultMessage: 'Are you sure you want to remove this member from the group?',
  },
  itsYou: {
    id: 'studio.bDz3Hi',
    defaultMessage: 'It’s you!',
  },
});
